import React from 'react';
import SuccessPage from 'components/new/SuccessPage';
import { PARTNER_TRANSFERS_CREATE } from 'adminConstants/routes';

const PartnerTransferSuccessPage: React.FC = () => {
  return (
    <SuccessPage
      title="Partner transfer has been approved successfully"
      content="The partner transfer has been processed and all allocations have been updated accordingly."
      primaryButton={{
        label: 'Create another partner transfer',
        link: PARTNER_TRANSFERS_CREATE,
      }}
    />
  );
};

export default PartnerTransferSuccessPage;
